import { and, any, or } from 'ramda'
import VueRouter from 'vue-router'
import { hasRight } from '@/service/session/permission'
import {
  hasValidAccessToken,
  CheckLocalRefreshToken,
  RefreshAndStoreToken
} from '@/service/session/token'

export const QUERY_FROM = 'from'

export function registerAuthHook(router: VueRouter) {
  router.beforeEach(async (to, from, next) => {
    //检查当前accesstoken是否已过期
    let isAuthed = hasValidAccessToken()
    //过期则尝试使用refreshtoken换取新的token
    if (!isAuthed) {
      //检查refreshtoken是否过期
      const isRefreshTokenOk = CheckLocalRefreshToken()
      //未过期则换取新的accesstoken
      if (isRefreshTokenOk) {
        const refreshRes = await RefreshAndStoreToken()
        isAuthed = true
        if (!refreshRes) {
          next({ path: 'login', query: { [QUERY_FROM]: to.fullPath } })
        }
      }
    }
    const pass = or(
      any(route => route.meta.public, to.matched),
      and(isAuthed, hasRight(to.meta!.key))
    )

    if (pass) {
      next()
    } else if (isAuthed) {
      next('401')
    } else {
      next({ path: 'login', query: { [QUERY_FROM]: to.fullPath } })
    }
  })
}
